// extracted by mini-css-extract-plugin
export var chevronIcon = "_48-2";
export var teamName = "_48-1";
export var teamSwitcherButton = "_48-0";